<style>


</style>

<template>

  <div>
    <select class="form-select" title="Path" @change="selectDate()" v-model="selectedDay">
      <option :value="null">all days</option>
      <option v-for="d in allDates" :value="d">{{ getCalendarDateName(d) }}</option>
    </select>

    <div class="clearfix"></div>

    <div class="course-schedules-calendar">

      <div class="d-flex flex-row flex-nowrap align-content-stretch"
           v-if="dates.length > 0 && hours.length > 0 && calendar">
        <div class="hours flex-shrink-1">
          <div class="label">&nbsp;</div>
          <div class="hour" v-for="hour in hours">
            {{ hour }}:00
          </div>
        </div>
        <div class="day flex-grow-1" v-for="day in dates">
          <div class="label">{{ getCalendarDateName(day) }}</div>
          <div class="hour" v-for="hour in hours"
               :class="{'unavailable': !isEditableHour(day, hour, true)}">
            <div v-if="calendar[day.format('YYYY-M-D')] && calendar[day.format('YYYY-M-D')][hour]"
                 class="schedule-wrap">
              <div class="schedule-card d-flex flex-row align-items-stretch"
                   v-for="card in calendar[day.format('YYYY-M-D')][hour]"
                   :style="cardDimensions(card)" :id="'schedule_' + card.id"
                   @click="showScheduleDetails(card)">
                <div class="card-course d-flex flex-column align-items-stretch flex-fill">
                  <div class="course flex-fill">
                    <div class="name"><a :href="card.course.link" target="_blank"
                                         :title="card.course.name"
                                         :style="{color: card.course.type.color}">{{
                        card.course.name
                      }}</a>
                      <span v-if="card.type === 'wait'" class="small text-muted">[wait]</span>
                    </div>
                    <div class="trainer" v-if="card.trainer"><a :style="{color: card.trainer.color}"
                                                                :href="card.trainer.link"
                                                                target="_blank">{{
                        card.trainer.name
                      }}</a></div>
                    <span v-if="card.guest_ids && Array.isArray(card.guest_ids)">{{
                        card.guest_ids.length
                      }} guests</span>
                  </div>
                  <div class="schedule" @click="showScheduleDetails(card)">
                    <i class="far fa-calendar-alt float-right"></i>
                    {{ dateFormat(card.from, 'h:mm a') }} - {{ dateFormat(card.till, 'h:mm a') }}
                  </div>
                </div>

              </div>
            </div>
            <div v-if="isEditableHour(day, hour, true)"
                 class="schedule-placement">
              <div class="add-schedule" @click="addSchedule(day, hour)">
                add a schedule
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>
  </div>

</template>

<script>

const mixinDayJs = require('../../helpers/vue_mixins').mixinDayJs;
const mixinErrorHandler = require('../../helpers/vue_mixins').mixinErrorHandler;

export default {
  mixins: [mixinDayJs, mixinErrorHandler],
  props: {
    course_schedules: Array,
    from: String,
    till: String,
    permissions: Object
  },
  data() {
    return {
      start: {},
      end: {},
      dates: [],
      allDates: [],
      hours: [],
      calendar: {},
      courseSchedules: [],
      calendarLoading: {},
      windowWidth: 0,
      courseScheduleTimeSlots: {},
      selectedDay: null,
      allow: {
        create: true,
        edit: true,
        show: true,
      }
    }
  },
  mounted() {
    this.init();
    this.windowWidth = window.innerWidth;
  },
  methods: {
    init() {
      if (this.permissions) {
        _.merge(this.allow, this.permissions);
      }
      this.prepareCalendar();
    },
    getCalendarDateName(day) {
      return this.dateFormat(day, 'dddd, D MMM');
    },
    selectDate() {
      if (!this.selectedDay) {
        this.dates = this.getAllDatesInRange();
      } else {
        this.dates = [this.selectedDay];
      }
    },
    prepareCalendar() {
      this.courseSchedules = this.course_schedules;
      const range = this.getDatesRangeFromSchedules();
      if (!this.from) {
        this.start = range.start;
      } else {
        this.start = dayjs(this.from);
      }
      if (!this.till) {
        this.end = range.end;
      } else {
        this.end = dayjs(this.till);
      }
      this.dates = this.getAllDatesInRange();
      this.allDates = this.dates;
      this.buildCalendar();
    },
    getAllDatesInRange() {
      let d = this.start.clone();
      let dates = [];
      if (this.end.isBefore(this.start)) {
        // console.log({
        //     start: this.start,
        //     end: this.end
        // });
        throw new Error('End date is before start date');
      }
      let i = 0;
      while (d.isSameOrBefore(this.end)) {
        i++;
        if (i > 100) {
          throw new Error('More then 100 days in period');
        }
        dates.push(d.clone());
        d = d.add(1, 'days');
      }
      return dates;
    },
    buildCalendar() {
      this.getHoursRangeFromSchedules();
      this.buildScheduleCards();
    },
    getDatesRangeFromSchedules() {
      const schedules = this.courseSchedules;
      let dates = [];
      for (let i = 0; i < schedules.length; i++) {
        if (schedules[i].from) {
          let f = this.dateSetTime(schedules[i].from, 0, 0);
          dates.push(f.unix());
        }
        if (schedules[i].till) {
          let t = this.dateSetTime(schedules[i].till, 0, 0);
          dates.push(t.unix());
        }
      }
      _.uniq(dates);

      let maxDate = 0;
      let minDate = 0;
      if (dates.length === 0) {
        throw new Error('Empty date list');
      }
      maxDate = _.max(dates);
      minDate = _.min(dates);
      let start = dayjs.unix(minDate);
      start = this.dateSetTime(start, 0, 0)
      let end = dayjs.unix(maxDate);
      end = this.dateSetTime(end, 23, 59)

      return {
        start: start,
        end: end,
      }
    },
    getHoursRangeFromSchedules() {
      const schedules = this.courseSchedules;
      let hours = [];
      for (let i = 0; i < schedules.length; i++) {
        if (schedules[i].from) {
          let f = dayjs(schedules[i].from).hour();
          hours.push(f);
          if (schedules[i].till) {
            let t = dayjs(schedules[i].till).hour();
            if (t > f) {
              hours.push(t);
            }
          }
        }
      }
      let maxHourLimit = 20;
      let minHourLimit = 7;
      let maxHour = 0;
      let minHour = 0;
      if (hours.length > 1) {
        maxHour = _.max(hours) + 1;
        minHour = _.min(hours) - 1;
        if (maxHour < maxHourLimit) {
          maxHour = maxHourLimit;
        }
        if (minHour > minHourLimit) {
          minHour = minHourLimit;
        }
      }
      let newHours = [];
      for (let i = minHour; i <= maxHour; i++) {
        newHours.push(i);
      }
      this.hours = newHours;
    },

    isEditableHour() {
      return true;
    },

    buildScheduleCards() {
      const schedules = this.courseSchedules;
      let calendarLoading = {};
      for (let i = 0; i < schedules.length; i++) {
        let start = dayjs(schedules[i].from);
        let end = dayjs(schedules[i].till);
        let startDay = start.format('YYYY-M-D');
        let startHour = start.hour();
        let endHour = end.hour();
        if (end.minute() === 0) {
          endHour = endHour - 1;
        }
        if (_.isUndefined(calendarLoading[startDay])) {
          calendarLoading[startDay] = {};
        }
        for (let j = startHour; j <= endHour; j++) {
          if (_.isUndefined(calendarLoading[startDay][j])) {
            calendarLoading[startDay][j] = [];
          }
          if (_.indexOf(calendarLoading[startDay][j], schedules[i].id) === -1) {
            calendarLoading[startDay][j].push(schedules[i].id);
          }
        }
        this.courseScheduleTimeSlots[schedules[i].id] = {
          start: start,
          end: end,
        };
      }
      //console.log(calendarLoading);
      calendarLoading = this.sortCalendarLoadingByScheduleStart(calendarLoading);

      // calendarLoading = _.map(calendarLoading, (d) => {
      //     if (d.length > 1) {
      //
      //     }
      // });

      this.calendarLoading = calendarLoading;
      let calendar = {};
      for (let i = 0; i < schedules.length; i++) {
        let start = dayjs(schedules[i].from);
        let end = dayjs(schedules[i].till);
        let startDay = start.format('YYYY-M-D');
        let startHour = start.hour();
        let endHour = end.hour();
        if (_.isUndefined(calendar[startDay])) {
          calendar[startDay] = {};
        }
        if (_.isUndefined(calendar[startDay][startHour])) {
          calendar[startDay][startHour] = {};
        }
        let cardId = schedules[i].id;
        if (_.isUndefined(calendar[startDay][startHour][cardId])) {
          calendar[startDay][startHour][cardId] = this.buildScheduleCard(schedules[i]);
        }
        let width = 100;
        let offset = 0;
        if (!_.isUndefined(calendarLoading[startDay])) {
          //console.log('found '  + startDay);
          if (!_.isUndefined(calendarLoading[startDay][startHour])) {
            if (calendarLoading[startDay][startHour].length > 0) {
              let max = 1;
              for (let j = startHour; j <= endHour; j++) {
                if (!_.isUndefined(calendarLoading[startDay][j])) {
                  if (_.indexOf(calendarLoading[startDay][j], schedules[i].id) !== -1) {
                    let schedulesInHour = calendarLoading[startDay][j];
                    if (schedulesInHour.length > max) {
                      max = schedulesInHour.length;
                      // if (calendarLoading[startDay][j].length > 5) {
                      //     console.log(calendarLoading[startDay][j], startDay, j);
                      // }
                    }
                  }
                }
              }
              width = 100 / max;
              offset = _.indexOf(calendarLoading[startDay][startHour], schedules[i].id)
              if (offset < 0) {
                offset = 0;
              } else {
                offset = width * offset;
              }
            }
          }
        } else {
          //console.log('not found '  + startDay);
        }
        let height = calendar[startDay][startHour][cardId].duration * 2;
        let top = calendar[startDay][startHour][cardId].from.format('m') * 2;
        calendar[startDay][startHour][cardId].dimensions = {
          top: top,
          offset: offset,
          width: width,
          height: height
        };
      }

      this.calendar = calendar;
    },

    sortCalendarLoadingByScheduleStart(calendarLoading) {
      let sortedCalendar = {};
      _.forEach(calendarLoading, (hours, date) => {
        _.forEach(hours, (courseSchedules, hour) => {
          if (_.isUndefined(sortedCalendar[date])) {
            sortedCalendar[date] = {};
          }
          sortedCalendar[date][hour] = this.sortCourseSchedulesByStart(courseSchedules);
        });
      });

      return sortedCalendar;
    },
    sortCourseSchedulesByStart(courseSchedules) {
      if (courseSchedules.length > 1) {
        let sortedCourseSchedules = _.sortBy(courseSchedules, (courseScheduleId) => {
          let start = this.courseScheduleTimeSlots[courseScheduleId].start;
          return start.format('YYYY-M-D H:m:s');
        });
        return sortedCourseSchedules;
      }

      return courseSchedules;
    },

    buildScheduleCard(schedule) {
      let card = _.clone(schedule);
      //delete card.id;
      card.type = 'course_schedule';
      card.from = dayjs(card.from);
      card.till = dayjs(card.till);
      let duration = dayjs.duration(card.till.diff(card.from));
      card.duration = duration.asMinutes();
      return card;
    },

    cardDimensions(card) {
      let height = card.dimensions.height;
      if (height < 70) {
        height = 70;
      }
      let color = '';
      if (card.level && card.level.color) {
        color = card.level.color;
      }
      return {
        height: height + 'px',
        top: card.dimensions.top + 'px',
        width: card.dimensions.width - 0.5 + '%',
        marginLeft: card.dimensions.offset + '%',
        borderColor: color
      }
    },

    showScheduleDetails(card) {
      const courseSchedule = _.find(this.courseSchedules, c => c.id === card.id)
      this.$emit('details', {course_schedule: courseSchedule});
    },

    addSchedule(day, hour) {
      const newDate = dayjs(day).clone().hour(hour).minute(0).second(0)
      this.$emit('create', {date: newDate});
    },
  },
  watch: {
    course_schedules(newVal, oldVal) {
      this.init();
    }
  },
  computed: {}
}
</script>
